// import store from '@/js/store'

const enhancedEcommerce = 'EnhancedEcommerce'
const all = 'All'

const gaAction = {
  add: 'add', // 添加到购物车
  detail: 'detail', // 商品详情
  startCheckout: 'startCheckout', // 开始结账
  setShipping: 'setShipping', // 设置物流
  setPayment: 'setpayment', // 设置支付
  completedOrder: 'completedOrder', // 完成支付
  beginCheckout: 'beginCheckout', // 完成支付
}

const actionData = {
  // 查看详情
  [gaAction.detail]: {
    category: all,
    action: 'view_item',
    label: 'Viewed Product'
  },
  // 添加到购物车
  [gaAction.add]: {
    category: enhancedEcommerce,
    action: 'add_to_cart',
    label: 'Added Product'
  },
  // 开始购物
  [gaAction.startCheckout]: {
    category: enhancedEcommerce,
    action: 'checkout_progress',
    label: 'Started Order' 
  },
  // 设置运费
  [gaAction.setShipping]: {
    category: enhancedEcommerce,
    action: 'checkout_progress',
    label: 'Shipping Method'
  },
  // 设置支付
  [gaAction.setPayment]: {
    category: enhancedEcommerce,
    action: 'checkout_progress',
    label: 'Payment Method'
  },
  // 完成支付
  [gaAction.completedOrder]: {
    category: enhancedEcommerce,
    action: 'purchase',
    label: 'Completed Order'
  },
  // 完成支付
  [gaAction.beginCheckout]: {
    category: enhancedEcommerce,
    action: 'begin_checkout',
    label: 'Begin Checkout'
  }
}


export default {
  gaAction,
  // 页面浏览
  page(params = {}) {
    const { googleAnalysis } = window.store?.state || {}
    const { pathname, search } = window.location

    if (window.gtag && googleAnalysis?.enable) {
      window.gtag('config', googleAnalysis?.trackId, {
        path_location: window.location,
        page_path: `${pathname}${search}`,
        ...params
      })
    }
  },
  // 事件
  event(action, params) {
    const config = actionData[action];
    const { googleAnalysis } = window.store?.state || {};
    
    let enable = googleAnalysis?.enable;

    if (config.category === enhancedEcommerce) {
      enable = googleAnalysis.ecommerce // true or false
    }
    if (enable && window?.gtag) {
      const { pathname, search } = window.location
      window.gtag('event', config.action, {
        send_to: googleAnalysis?.trackId,
        event_category: config.category,
        event_action: config.label,
        event_label: config.label,
        page_path: `${pathname}${search}`,
        path_location: window.location,
        ...params
      })
    }
  }
}
